/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { TeamUserRoleType } from './TeamUserRoleType.js';
import {
    TeamUserRoleTypeFromJSON,
    TeamUserRoleTypeFromJSONTyped,
    TeamUserRoleTypeToJSON,
} from './TeamUserRoleType.js';
import type { User } from './User.js';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User.js';

/**
 * 
 * @export
 * @interface TeamUser
 */
export interface TeamUser {
    /**
     * 
     * @type {number}
     * @memberof TeamUser
     */
    teamId?: number;
    /**
     * 
     * @type {string}
     * @memberof TeamUser
     */
    teamName?: string;
    /**
     * 
     * @type {User}
     * @memberof TeamUser
     */
    user?: User;
    /**
     * 
     * @type {TeamUserRoleType}
     * @memberof TeamUser
     */
    role?: TeamUserRoleType;
}

/**
 * Check if a given object implements the TeamUser interface.
 */
export function instanceOfTeamUser(value: object): boolean {
    return true;
}

export function TeamUserFromJSON(json: any): TeamUser {
    return TeamUserFromJSONTyped(json, false);
}

export function TeamUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamUser {
    if (json == null) {
        return json;
    }
    return {
        
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'teamName': json['teamName'] == null ? undefined : json['teamName'],
        'user': json['user'] == null ? undefined : UserFromJSON(json['user']),
        'role': json['role'] == null ? undefined : TeamUserRoleTypeFromJSON(json['role']),
    };
}

export function TeamUserToJSON(value?: TeamUser | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'teamId': value['teamId'],
        'teamName': value['teamName'],
        'user': UserToJSON(value['user']),
        'role': TeamUserRoleTypeToJSON(value['role']),
    };
}

